import React from 'react';

const SEOParagraph = () => {
  return (
    <section className="py-12 bg-slate-50">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-slate-600 leading-relaxed">
          Homeowners searching for an{' '}
          <a href="/instant-hvac-estimate-new-orleans" className="text-[#0EA5E9] hover:underline">
            instant HVAC estimate
          </a>{' '}
          can now get real pricing online without waiting days for a contractor visit. Our platform provides
          accurate{' '}
          <a href="/hvac-pricing-new-orleans" className="text-[#0EA5E9] hover:underline">
            HVAC pricing online
          </a>
          , allowing you to compare options and receive an{' '}
          <a href="/instant-hvac-estimate-new-orleans" className="text-[#0EA5E9] hover:underline">
            instant AC quote
          </a>{' '}
          in minutes. Built for Louisiana homes.
        </p>
      </div>
    </section>
  );
};

export default SEOParagraph;
